import {
  ActivityBankFilter,
  ActivityFilter,
  getActivity,
  listActivities,
  listActivityBank,
  listLessonActivities,
} from '../services/activityServices';

export const activityQueries = {
  all: ['activities'] as const,

  get: (id: number) => ({
    queryKey: [...activityQueries.all, 'get', id] as const,
    queryFn: () => getActivity(id),
  }),

  lessonList: (lessonId: number, filters: ActivityFilter = {}) => ({
    queryKey: [
      ...activityQueries.all,
      'lessonList',
      lessonId,
      { filters },
    ] as const,
    queryFn: () => listLessonActivities(lessonId, filters),
  }),

  list: (filters: ActivityFilter = {}) => ({
    queryKey: [...activityQueries.all, 'list', { filters }] as const,
    queryFn: () => listActivities(filters),
  }),

  bankList: (filters: ActivityBankFilter = {}) => ({
    queryKey: [...activityQueries.all, 'bankList', { filters }] as const,
    queryFn: () => listActivityBank(filters),
  }),

  listInfinite: (filters: ActivityFilter = {}) => ({
    queryKey: [...activityQueries.list(filters).queryKey, 'infinite'] as const,
    queryFn: (ctx: { pageParam?: number }) =>
      listActivities({ ...filters, pageNumber: ctx.pageParam }),
  }),
};
